export type StatusVariant =
  | "active"
  | "locked"
  | "pending"
  | "Active"
  | "Revoked"
  // Terminal statuses (PosByTreasury.statusLabel), case-normalised for the badge's CSS class.
  | "blocked"
  | "idle"
  | "unassigned";
const merchantStatusMap: Record<number, StatusVariant> = {
  1: "Active",
  2: "Revoked",
};

export function getMerchantStatus(status: number): StatusVariant {
  return merchantStatusMap[status] ?? "Unknown";
}

const terminalStatusMap: Record<string, StatusVariant> = {
  ACTIVE: "active",
  BLOCKED: "blocked",
  IDLE: "idle",
  UNASSIGNED: "unassigned",
};

export function getTerminalStatus(statusLabel: string): StatusVariant {
  return terminalStatusMap[statusLabel] ?? "unassigned";
}

const MERCHANT_UTIL = { getMerchantStatus, getTerminalStatus };

export default MERCHANT_UTIL;
